{
  "name": "@reactive-agents/cli",
  "version": "0.13.0",
  "type": "module",
  "main": "./dist/index.js",
  "bin": {
    "rax": "dist/index.js",
    "reactive-agents": "dist/index.js"
  },
  "scripts": {
    "build": "tsup --config tsup.config.ts",
    "typecheck": "tsc --noEmit",
    "test": "bun test --reporter=dots"
  },
  "license": "MIT",
  "repository": {
    "type": "git",
    "url": "https://github.com/tylerjrbuell/reactive-agents-ts.git",
    "directory": "apps/cli"
  },
  "publishConfig": {
    "access": "public"
  },
  "files": [
    "dist",
    "README.md",
    "LICENSE"
  ],
  "dependencies": {
    "effect": "^3.10.0",
    "@reactive-agents/core": "0.13.0",
    "@reactive-agents/runtime": "0.13.0",
    "@reactive-agents/eval": "0.13.0",
    "@reactive-agents/llm-provider": "0.13.0",
    "@reactive-agents/a2a": "0.13.0",
    "@reactive-agents/trace": "0.13.0",
    "@reactive-agents/tools": "0.13.0",
    "@reactive-agents/memory": "0.13.0",
    "@reactive-agents/diagnose": "0.13.0",
    "chalk": "^5.4.0",
    "ora": "^8.2.0",
    "boxen": "^8.0.1"
  },
  "peerDependencies": {
    "@reactive-agents/cortex": "0.13.0"
  },
  "peerDependenciesMeta": {
    "@reactive-agents/cortex": {
      "optional": true
    }
  },
  "devDependencies": {
    "@reactive-agents/benchmarks": "0.13.0",
    "typescript": "^6.0.3",
    "bun-types": "latest"
  },
  "description": "rax — the Reactive Agents CLI for scaffolding, running, and inspecting AI agents",
  "keywords": [
    "ai",
    "agents",
    "cli",
    "typescript",
    "llm",
    "reactive-agents",
    "mcp",
    "agent-cli",
    "developer-tools"
  ],
  "homepage": "https://docs.reactiveagents.dev/",
  "bugs": {
    "url": "https://github.com/tylerjrbuell/reactive-agents-ts/issues"
  },
  "types": "./dist/index.d.ts"
}
